<mat-card [class.mat-elevation-z1]="'true'" [class.bmw-job-card]="detail?.isBmwJob">
  <div class="card-spacer">
    <div class="gobackmobile" style="    text-align: right;
    position: absolute;
    z-index:30;
    right: 15px; margin-top: 10px;"> <button class="mat-raised-button back-button" (click)="goBack()">Back</button></div>

    <!-- BMW Job layout: header, progress, map + History/Actions, details -->
    <ng-container *ngIf="detail?.isBmwJob">
      <header class="bmw-job-header">
        <h1 class="bmw-job-title">BMW Job #{{ detail.tourNumber || detail.amcoId }}</h1>
      </header>
      <div class="bmw-progress-bar" *ngIf="bmwDisplayStages.length">
        <ng-container *ngFor="let stage of bmwDisplayStages; let i = index">
          <span class="bmw-stage" [class.bmw-stage-active]="i === bmwDisplayStageIndex" [class.bmw-stage-done]="i < bmwDisplayStageIndex">{{ stage }}</span>
          <span class="bmw-stage-sep" *ngIf="i < bmwDisplayStages.length - 1">&gt;&gt;&gt;</span>
        </ng-container>
      </div>
      <div class="bmw-content">
        <div class="bmw-map-section">
          <div style="height: 66vh;" class="map-container bmw-map">
            <agm-map [latitude]="lat" [longitude]="lng" [zoom]="bmwMapZoom" (mapReady)="onMapReady($event)">
              <agm-circle
                *ngFor="let zone of geofenceZones"
                [visible]="showBmwGeofences && zone.locationType?.toLowerCase() !== 'border'"
                [latitude]="zone.latitude"
                [longitude]="zone.longitude"
                [radius]="zone.radiusMeters"
                [strokeColor]="getZoneColor(zone.locationType)"
                [strokeWeight]="zone.locationType?.toLowerCase() === 'tunnel' ? 3 : 2"
                [strokeOpacity]="0.9"
                [fillColor]="getZoneFillColor(zone.locationType)"
                [fillOpacity]="0.18">
              </agm-circle>
              <agm-marker
                *ngFor="let zone of geofenceZones"
                [visible]="showBmwGeofences && zone.locationType?.toLowerCase() === 'tunnel'"
                [latitude]="zone.latitude"
                [longitude]="zone.longitude"
                [title]="zone.name"
                [zIndex]="60">
                <agm-info-window>
                  <strong>{{ zone.name }}</strong><br>
                  <strong>Radius:</strong> {{ zone.radiusMeters }}m
                </agm-info-window>
              </agm-marker>
              <agm-polygon
                *ngFor="let zone of geofenceZones"
                [visible]="showBmwGeofences && zone.locationType?.toLowerCase() === 'border' && zone.polygonPoints?.length > 1"
                [paths]="zone.polygonPoints"
                [strokeColor]="getZoneColor(zone.locationType)"
                [strokeWeight]="2"
                [strokeOpacity]="0.9"
                [fillColor]="getZoneFillColor(zone.locationType)"
                [fillOpacity]="0.18">
              </agm-polygon>
              <agm-circle
                *ngFor="let zone of geofenceZones"
                [visible]="showBmwGeofences && zone.locationType?.toLowerCase() === 'border' && !(zone.polygonPoints?.length > 1)"
                [latitude]="zone.latitude"
                [longitude]="zone.longitude"
                [radius]="zone.radiusMeters"
                [strokeColor]="getZoneColor(zone.locationType)"
                [strokeWeight]="2"
                [strokeOpacity]="0.9"
                [fillColor]="getZoneFillColor(zone.locationType)"
                [fillOpacity]="0.18">
              </agm-circle>
              <agm-polyline
                *ngIf="showBmwGeofences && bmwVehiclePolylinePoints.length > 1"
                [strokeColor]="'#15457e'"
                [strokeWeight]="2"
                [editable]="false"
                [visible]="true">
                <agm-polyline-point
                  *ngFor="let point of bmwVehiclePolylinePoints"
                  [latitude]="point.lat"
                  [longitude]="point.lng">
                </agm-polyline-point>
              </agm-polyline>
              <agm-marker [latitude]="lat" [longitude]="lng" [title]="detail?.destination" [draggable]="false"
                [iconUrl]="{url:getIcon('Delivery',detail?.updateBy), scaledSize: {width: 45,height: 60}}">
                <agm-info-window><strong>Destination: {{detail?.destination}}</strong></agm-info-window>
              </agm-marker>
              <agm-marker *ngIf="(vehicleDet?.positionDateTime !== undefined || vehicleDet?.positionDateTime !== null)"
                [latitude]="vehicleDet?.latitude" [longitude]="vehicleDet?.longitude" [draggable]="false"
                [iconUrl]="detail?.updateTypeName === 'Driver Rest Start' ? {url:'./assets/images/Driver-rest-icon.png', scaledSize: {width: 45,height: 55} } : {url: getTruckIcon((detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd), detail?.estimatedDateTime, (detail?.type === 'Collection' ? detail?.actualCollectionDate : detail?.actualDeliveryDate)), scaledSize: {width: 45,height: 55} }">
                <agm-info-window>
                  <strong>Reg Nr: {{vehicleDet?.vehicleLicensePlate}}</strong><br>
                  <strong>Position Date: {{vehicleDet?.positionDateTime | date: 'dd-MMM-yyyy HH:mm'}}</strong>
                </agm-info-window>
              </agm-marker>
              <agm-marker [latitude]="collectionLat" [longitude]="collectionLng" [draggable]="false"
                [iconUrl]="{url:getIcon('Collection',detail?.updateBy), scaledSize: {width: 45,height: 60}}">
                <agm-info-window><strong>Collection: {{detail?.collectionAddress}}</strong></agm-info-window>
              </agm-marker>
              <agm-marker
                *ngFor="let event of bmwVehicleMarkerEvents"
                [visible]="showBmwGeofences"
                [latitude]="event.latitude"
                [longitude]="event.longitude"
                [title]="getEventTitle(event)"
                [iconUrl]="{ url: 'assets/images/amco-green-truck.png', scaledSize: { width: 35, height: 45 } }">
                <agm-info-window>
                  <div>
                    <strong>Reg:</strong> {{ event.vehicleLicensePlate }}<br>
                    <strong>Date:</strong> {{ event.positionDateTime | date: 'dd-MMM-yyyy HH:mm' }}<br>
                    <strong>City:</strong> {{ event.nearestCity }}<br>
                    <strong>Address:</strong> {{ event.addressInfo }}
                  </div>
                </agm-info-window>
              </agm-marker>
              <agm-marker
                *ngFor="let marker of replayMarkers; let markerIndex = index"
                [latitude]="marker.latitude"
                [longitude]="marker.longitude"
                [title]="getReplayMarkerTitle(marker)"
                [zIndex]="isBorderCrossed(marker.milestoneName) ? 200 : isBorderMilestone(marker.milestoneName) ? 100 : 10"
                [iconUrl]="{ url: getReplayMarkerIconUrl(marker.milestoneName), scaledSize: getReplayMarkerIconSize(marker.milestoneName, isReplayMarkerSelected(markerIndex)) }">
                <agm-info-window>
                  <div class="replay-info">
                    <strong [class.milestone-label]="!isBorderCrossed(marker.milestoneName)"
                            [class.border-crossed-label]="isBorderCrossed(marker.milestoneName)">
                      {{ marker.milestoneName }}
                    </strong><br>
                    <strong>Time:</strong> {{ marker.eventTime | date: 'dd-MMM-yyyy HH:mm' }}<br>
                    <strong>Reg:</strong> {{ marker.vehicleLicensePlate }}<br>
                    <strong>City:</strong> {{ marker.nearestCity }}<br>
                    <strong>Country:</strong> {{ marker.countryCode }}
                  </div>
                </agm-info-window>
              </agm-marker>
              <agm-circle
                *ngIf="selectedMapFocus"
                [latitude]="selectedMapFocus.lat"
                [longitude]="selectedMapFocus.lng"
                [radius]="1200"
                [strokeColor]="'#e91e63'"
                [strokeWeight]="3"
                [strokeOpacity]="0.95"
                [fillColor]="'#e91e63'"
                [fillOpacity]="0.06"
                [zIndex]="250">
              </agm-circle>
            </agm-map>
          </div>
        </div>
        <div class="bmw-panel">
          <mat-tab-group class="bmw-tabs">
            <mat-tab label="History">
              <ng-container *ngIf="(tourUpdateHistory$ | async) as history">
                <div class="bmw-tab-content bmw-history-list">
                  <div class="bmw-history-item" *ngFor="let item of getFilteredBmwHistory(history)">
                    <span class="bmw-history-action">{{ item.updateType }}</span>
                    <span class="bmw-history-meta">{{ (item.date || item.updatedAt) | date: 'dd-MMM-yyyy HH:mm' }} <span *ngIf="item.user"> · {{ getTourHistoryUserDisplay(item.user) }}</span></span>
                    <p class="bmw-history-note" *ngIf="item.note">{{ item.note }}</p>
                  </div>
                  <p class="bmw-history-text muted" *ngIf="getFilteredBmwHistory(history).length === 0 && detail">No history yet.</p>
                </div>
              </ng-container>
            </mat-tab>
            <mat-tab label="Actions">
              <div class="bmw-tab-content bmw-actions">
                <div class="bmw-actions-layout">
                  <div class="bmw-actions-row">
                    <button *ngIf="nextActionButtonLabel && !isFerryAction(nextActionButtonLabel)" class="mat-raised-button bmw-action-btn" (click)="confirmAndSendConsignmentStatus()" [disabled]="(isSendingConsignmentStatus$ | async)">
                      {{ (isSendingConsignmentStatus$ | async) ? 'Sending…' : nextActionButtonLabel }}
                    </button>
                    <button *ngIf="ferryActionButtonLabel" class="mat-raised-button bmw-action-btn" (click)="confirmAndSendFerryStatus()" [disabled]="(isSendingConsignmentStatus$ | async)">
                      {{ (isSendingConsignmentStatus$ | async) ? 'Sending…' : ferryActionButtonLabel }}
                    </button>
                    <button *ngIf="showCrossedBorderButton" class="mat-raised-button bmw-action-btn" (click)="confirmAndSendCrossedBorder()" [disabled]="(isSendingConsignmentStatus$ | async)">
                      {{ (isSendingConsignmentStatus$ | async) ? 'Sending…' : 'Crossed Border' }}
                    </button>
                    <button *ngIf="customsActionButtonLabel" class="mat-raised-button bmw-action-btn" (click)="confirmAndSendCustomsStatus()" [disabled]="(isSendingConsignmentStatus$ | async)">
                      {{ (isSendingConsignmentStatus$ | async) ? 'Sending…' : customsActionButtonLabel }}
                    </button>
                    <button type="button" mat-raised-button class="bmw-delay-btn" (click)="openReportDelayDialog()" [disabled]="isReportingDelay || !detail?.amcoId || !detail?.tourId || !detail?.transportOrderNumber">
                      {{ isReportingDelay ? 'Submitting…' : 'Report Delay' }}
                    </button>
                    <button type="button" mat-raised-button class="bmw-documents-btn" (click)="openInputLocationDialog()" [disabled]="!detail?.id">
                      Input Location
                    </button>
                    <button type="button" mat-raised-button class="bmw-documents-btn" (click)="openDocumentsDialog()" [disabled]="!detail?.amcoId">
                      Documents
                    </button>
                    <button type="button" mat-raised-button class="bmw-documents-btn" (click)="openBmwChatsDialog()" [disabled]="!detail?.id || !detail?.amcoId">
                      Chats
                    </button>
                  </div>
                  <div class="bmw-actions-shipment-summary" *ngIf="detail">
                    <div class="bmw-actions-summary-line">
                      <span class="bmw-actions-summary-label">Total packages</span>
                      <span class="bmw-actions-summary-value">{{ detail.expectedGoods ?? '—' }}</span>
                    </div>
                    <div class="bmw-actions-summary-line">
                      <span class="bmw-actions-summary-label">Goods weight</span>
                      <span class="bmw-actions-summary-value">{{ detail.goodsWeight ?? '—' }}</span>
                    </div>
                    <div class="bmw-actions-summary-line">
                      <span class="bmw-actions-summary-label">Actual goods</span>
                      <span class="bmw-actions-summary-value">{{ detail.actualGoods ?? '—' }}</span>
                    </div>
                  </div>
                </div>
                <p class="bmw-history-text muted" *ngIf="!nextActionButtonLabel && detail">No further actions. Job delivered.</p>
              </div>
            </mat-tab>
            <mat-tab label="Geofencing">
              <div class="bmw-tab-content bmw-geofencing">
                <div class="bmw-geofencing-actions">
                  <button type="button" mat-raised-button class="bmw-documents-btn"
                          (click)="toggleBmwGeofencing()"
                          [disabled]="isLoadingBmwGeofences || isReplayingBmwGeofencing">
                    {{ showBmwGeofences ? 'Hide Geofencing On Map' : (hasLoadedBmwGeofences ? 'Show Geofencing On Map' : 'Load Geofencing On Map') }}
                  </button>
                  <button type="button" mat-raised-button class="bmw-action-btn"
                          (click)="replayBmwGeofencing()"
                          [disabled]="!detail?.id || isLoadingBmwGeofences || isReplayingBmwGeofencing">
                    {{ isReplayingBmwGeofencing ? 'Replaying…' : 'Evaluate Geofencing' }}
                  </button>
                </div>

                <div class="bmw-geofencing-status">
                  <span *ngIf="isLoadingBmwGeofences">Loading geofence zones…</span>
                  <span *ngIf="!isLoadingBmwGeofences && showBmwGeofences"><br>{{ geofenceZones.length }} geofence zone(s) visible on the map</span>
                  <span *ngIf="isReplayingBmwGeofencing"><br>Evaluating geofence triggers…</span>
                  <span *ngIf="!isReplayingBmwGeofencing && replayMarkers?.length > 0"><br>{{ replayMarkers.length }} trigger(s) found</span>
                  <span *ngIf="!isReplayingBmwGeofencing && hasBmwReplayResult && replayMarkers?.length === 0"><br>No triggers found</span>
                </div>

                <div class="bmw-geofence-legend" *ngIf="showBmwGeofences && geofenceZones?.length > 0">
                  <span class="legend-title">Zones:</span>
                  <span class="zone-chip collection"><span class="zone-dot"></span> Collection</span>
                  <span class="zone-chip delivery"><span class="zone-dot"></span> Delivery</span>
                  <span class="zone-chip port"><span class="zone-dot"></span> Port</span>
                  <span class="zone-chip border"><span class="zone-dot"></span> Border</span>
                  <span class="zone-chip tunnel"><span class="zone-dot"></span> Tunnel</span>
                </div>

                <div class="bmw-geofence-triggers" *ngIf="replayMarkers?.length > 0">
                  <button type="button"
                        *ngFor="let marker of replayMarkers; let markerIndex = index"
                        class="bmw-trigger-chip"
                        [class.bmw-trigger-chip-border]="isBorderCrossed(marker.milestoneName)"
                        [class.bmw-trigger-chip-tunnel]="isTunnelMilestone(marker.milestoneName)"
                        [class.bmw-trigger-chip-selected]="isReplayMarkerSelected(markerIndex)"
                        (click)="focusReplayMarker(marker, markerIndex)">
                    {{ marker.milestoneName }} · {{ marker.eventTime | date: 'dd-MMM-yyyy HH:mm' }}
                  </button>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
      <div class="bmw-details-section" *ngIf="detail">
        <table class="details-table bmw-details-table">
          <tr><th class="header-column">AMCO ID</th><td>{{ detail.amcoId }}</td></tr>
          <tr><th class="header-column">Consignment Number</th><td>{{ detail.consignmentNumber }}</td></tr>
          <tr><th class="header-column">Transport Order Number</th><td>{{ detail.transportOrderNumber }}</td></tr>
          <tr><th class="header-column">Tour Number</th><td>{{ detail.tourNumber }}</td></tr>
          <tr><th class="header-column">Order Date</th><td>{{ detail.orderdate }}</td></tr>
          <tr><th class="header-column">Department</th><td>{{ detail.departmentName }}</td></tr>
          <tr><th class="header-column">Owning User</th><td>{{ detail.owningUser }}</td></tr>
          <tr><th class="header-column">Order Type</th><td>{{ detail.orderType }}</td></tr>
          <tr><th class="header-column">Shipment Mode</th><td>{{ detail.shipmentMode }}</td></tr>
          <tr><th class="header-column">Special instructions</th><td>{{ detail.note }}</td></tr>
          <tr><th class="header-column">Vehicle Type</th><td>{{ detail.vechicleTypes }}</td></tr>
          <tr><th class="header-column">Customer</th><td>{{ detail.customerName }} - {{ detail.destination }}</td></tr>
          <tr><th class="header-column">Customer Contact</th><td>{{ detail.customerContact }}</td></tr>
          <tr><th class="header-column">Customer Contacts For Tracking</th><td>{{ detail.customerContactEmail }}</td></tr>
          <tr><th class="header-column">PO Number</th><td>{{ detail.poNumber }}</td></tr>
          <tr><th class="header-column">Customer Reference Number</th><td>{{ detail.customerReferenceNumber }}</td></tr>
          <tr><th class="header-column">Declaration Type</th><td>{{ detail.declarationType }}</td></tr>
          <tr><th class="header-column">Collection Address</th><td>{{ detail.senderName }} - {{ detail.collectionAddress }}</td></tr>
          <tr><th class="header-column">Planned Loading Start   </th><td>{{ detail.plannedLoadingStart | date: 'dd-MMM-yyyy HH:mm':'UTC' }}</td></tr>
          <tr><th class="header-column">Planned Loading End     </th><td>{{ detail.plannedLoadingEnd | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
          <tr><th class="header-column">Port/Airport of Departure</th><td>{{ detail.portAirportOfDeparture }}</td></tr>
          <tr><th class="header-column">Port/Airport of Arrival</th><td>{{ detail.portAirportOfArrival }}</td></tr>
          <tr><th class="header-column">Delivery Address                  </th><td>{{ detail.name }} - {{detail.destination}}</td></tr>
          <tr><th class="header-column">Planned Delivery Start  </th><td>{{ detail.plannedDeliveryStart  | date: 'dd-MMM-yyyy HH:mm':'UTC' }}</td></tr>
          <tr><th class="header-column">Planned Delivery End    </th><td>{{ detail.plannedDeliveryEnd  | date: 'dd-MMM-yyyy HH:mm'  }}</td></tr>
          <tr><th class="header-column">Carrier            </th><td>{{ detail.carrier }}</td></tr>
            <tr><th class="header-column">Carrier Contact Email </th><td>{{ detail.carrierContactEmail }}</td>
              <div class="gobackmobile" style="text-align: right; position: absolute;z-index:30; right: 15px; padding-top: 1px !important;">
                <button class="mat-raised-button back-button" (click)="editCarrierContactEmail(detail.carrierContactEmail)">Edit</button>
              </div>
            </tr>
          <tr><th class="header-column">Assigned Vehicle</th><td>{{ detail.regNumber }}</td></tr>
          <tr><th class="header-column">Trailer Registration Number</th><td>{{ detail.trailerRegNumber }}</td>
              <div class="gobackmobile" style="text-align: right; position: absolute;z-index:30; right: 15px; padding-top: 1px !important;">
                  <button class="mat-raised-button back-button" (click)="editTrailerRegNumber(detail.trailerRegNumber)">Edit</button>
              </div>
          </tr>
          <tr><th class="header-column">Driver Name</th><td>{{ detail.driverName }}</td>
              <div class="gobackmobile" style="text-align: right; position: absolute;z-index:30; right: 15px; padding-top: 1px !important;">
                  <button class="mat-raised-button back-button" (click)="editDriverDetails(detail.driverName, detail.cellphoneNumber)">Edit Driver</button>
              </div>
          </tr>
          <tr><th class="header-column">Driver Cellphone Number</th><td>{{ detail.cellphoneNumber }}</td></tr>
          <tr><th class="header-column">Tracking Url</th><td><a href="{{ detail.trackingUrl }}" target="_blank">{{ detail.trackingUrl }}</a></td></tr>
          <tr><th class="header-column">Overseas Agent</th><td>{{ detail.overseasAgent }}</td></tr>
          <tr><th class="header-column">Category</th><td>{{ detail.categoryName }}</td></tr>
          <tr><th class="header-column">Planned Time</th><td>{{ detail.targetDateTime | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
          <tr><th class="header-column">Latest ETA</th><td>{{ detail.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm'  }}</td></tr>
          <tr><th class="header-column">Assigned User</th><td>{{ detail.assignedUser }}</td></tr>
          <tr><th class="header-column">Last Modified</th><td>{{ detail.lastModifiedDate | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
          <tr><th class="header-column">Last Action Date</th><td>{{ detail.lastActionDate | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
          <tr><th class="header-column">Last Action</th><td>{{ detail.latestAction }}</td></tr>
          <tr><th class="header-column">Next Update Due By</th><td>{{ detail.updateDueDate | date: 'dd-MMM-yyyy HH:mm' }}</td>
          <tr><th class="header-column">Note</th><td>{{ detail.latestNote }}</td></tr>

          <tr><th class="header-column">EADMRN No</th><td>{{ detail.eadmrnNo }}</td></tr>
          <tr><th class="header-column">TADLRN No</th><td>{{ detail.tadlrnNo }}</td></tr>
          <tr><th class="header-column">Customs Entry No</th><td>{{ detail.customsEntryNno }}</td></tr>
          <tr><th class="header-column">HMRC Status</th><td>{{ detail.hmrcStatus }}</td></tr>
          <tr><th class="header-column">Customs Entry No Sent To Carrier</th><td>{{ detail.customsEntryNoSentToCarrier === 0 ? 'No' : 'Yes' }}</td></tr>
          <tr><th class="header-column">EAD Filed</th><td>{{ detail.eadFiled === 0 ? 'No' : 'Yes' }}</td></tr>
          <tr><th class="header-column">EAD Sent</th><td>{{ detail.eadSent === 0 ? 'No' : 'Yes' }}</td></tr>
          <tr><th class="header-column">EXS Filed</th><td>{{ detail.exsFiled === 0 ? 'No' : 'Yes' }}</td></tr>
          <tr><th class="header-column">EXS Sent</th><td>{{ detail.exsSent === 0 ? 'No' : 'Yes' }}</td></tr>
          <tr><th class="header-column">GMR Filed</th><td>{{ detail.gmrFiled === 0 ? 'No' : 'Yes' }}</td></tr>
          <tr><th class="header-column">GMR Sent To Carrier</th><td>{{ detail.gmrSentToCarrier === 0 ? 'No' : 'Yes' }}</td></tr>
          <tr><th class="header-column">TADLRN Sent</th><td>{{ detail.tadlrnSent === 0 ? 'No' : 'Yes' }}</td></tr>
          <tr><th class="header-column">Customs Status</th><td>{{ detail.customsStatus }}</td></tr>
        </table>
      </div>
    </ng-container>

    <!-- Default layout (non-BMW) -->
    <div class="table-container" *ngIf="!detail?.isBmwJob">
        <mat-tab-group class="table-container">
            <mat-tab label="Shipment Details">
                <div class="details-container" *ngIf="detail">
                    <table class="details-table">
                        <tr><th class="header-column">AMCO ID</th><td>{{ detail.amcoId }}</td></tr>
                        <tr><th class="header-column">Consignment Number     </th><td>{{ detail.consignmentNumber }}</td></tr>
                        <tr><th class="header-column">Transport Order Number  </th><td>{{ detail.transportOrderNumber }}</td></tr>
                        <tr><th class="header-column">Tour Number</th><td>{{ detail.tourNumber }}</td></tr>
                        <tr><th class="header-column">Order Date             </th><td>{{ detail.orderdate }}</td></tr>
                        <tr><th class="header-column">Department</th><td>{{ detail.departmentName }}</td></tr>
                        <tr><th class="header-column">Owning User</th><td>{{detail.owningUser}}</td></tr>
                        <tr><th class="header-column">Order Type             </th><td>{{ detail.orderType }}</td></tr>
                        <tr><th class="header-column">Shipment Mode</th><td>{{detail.shipmentMode}}</td></tr>
                        <tr><th class="header-column">Special Instructions</th><td>{{ detail.note }}</td></tr>
                        <tr><th class="header-column">Vehicle Type</th><td>{{ detail.vechicleTypes }}</td></tr>
                        <tr><th class="header-column">Customer                  </th><td>{{ detail.customerName }} - {{detail.destination}}</td></tr>
                        <tr><th class="header-column">Customer Contact</th><td>{{ detail.customerContact }}</td></tr>
                        <tr>
                            <th class="header-column">Customer Contacts For Tracking</th><td>{{ detail.customerContactEmail }}</td>
                            <div class="gobackmobile" style="text-align: right; position: absolute;z-index:30; right: 15px; padding-top: 1px !important;">
                                <button class="mat-raised-button back-button" (click)="editCustContact(detail.customerContactEmail)">Edit</button>
                                <button class="mat-raised-button back-button" (click)="deleteCustContact()" [disabled]="!detail.customerContactEmail">Delete</button>
                            </div>
                        </tr>
                        <tr><th class="header-column">PO Number</th><td>{{ detail.poNumber }}</td></tr>
                        <tr><th class="header-column">Customer Reference Number</th><td>{{ detail.customerReferenceNumber }}</td></tr>
                        <tr><th class="header-column">Customer uses RPA form</th><td>{{ detail.rpaRequired === 1 ? 'No' : 'Yes' }}</td></tr>
                        <tr><th class="header-column">Declaration Type</th><td>{{ detail.declarationType }}</td></tr>
                        <tr><th class="header-column">Collection Address  </th><td>{{ detail.senderName }} - {{detail.collectionAddress}}</td></tr>
                        <tr><th class="header-column">Planned Loading Start   </th><td>{{ detail.plannedLoadingStart | date: 'dd-MMM-yyyy HH:mm':'UTC' }}</td></tr>
                        <tr><th class="header-column">Planned Loading End     </th><td>{{ detail.plannedLoadingEnd | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
                        <tr><th class="header-column">Port/Airport of Departure</th><td>{{ detail.portAirportOfDeparture }}</td></tr>
                        <tr><th class="header-column">Port/Airport of Arrival</th><td>{{ detail.portAirportOfArrival }}</td></tr>
                        <tr><th class="header-column">Delivery Address                  </th><td>{{ detail.name }} - {{detail.destination}}</td></tr>
                        <tr><th class="header-column">Planned Delivery Start  </th><td>{{ detail.plannedDeliveryStart  | date: 'dd-MMM-yyyy HH:mm':'UTC' }}</td></tr>
                        <tr><th class="header-column">Planned Delivery End    </th><td>{{ detail.plannedDeliveryEnd  | date: 'dd-MMM-yyyy HH:mm'  }}</td></tr>
                        <tr><th class="header-column">Carrier            </th><td>{{ detail.carrier }}</td></tr>
                        <tr><th class="header-column">Carrier Contact Email </th><td>{{ detail.carrierContactEmail }}</td>
                          <div class="gobackmobile" style="text-align: right; position: absolute;z-index:30; right: 15px; padding-top: 1px !important;">
                            <button class="mat-raised-button back-button" (click)="editCarrierContactEmail(detail.carrierContactEmail)">Edit</button>
                          </div>
                        </tr>
                        <tr><th class="header-column">Assigned Vehicle</th><td>{{ detail.regNumber }}</td></tr>
                        <tr><th class="header-column">Trailer Registration Number</th><td>{{ detail.trailerRegNumber }}</td>
                            <div class="gobackmobile" style="text-align: right; position: absolute;z-index:30; right: 15px; padding-top: 1px !important;">
                                <button class="mat-raised-button back-button" (click)="editTrailerRegNumber(detail.trailerRegNumber)">Edit</button>
                            </div>
                        </tr>
                        <tr><th class="header-column">Driver Name</th><td>{{ detail.driverName }}</td>
                            <div class="gobackmobile" style="text-align: right; position: absolute;z-index:30; right: 15px; padding-top: 1px !important;">
                                <button class="mat-raised-button back-button" (click)="editDriverDetails(detail.driverName, detail.cellphoneNumber)">Edit Driver</button>
                            </div>
                        </tr>
                        <tr><th class="header-column">Driver Cellphone Number</th><td>{{ detail.cellphoneNumber }}</td></tr>
                        <tr><th class="header-column">Tracking Url</th><td><a href="{{ detail.trackingUrl }}" target="_blank">{{ detail.trackingUrl }}</a></td></tr>
                        <tr><th class="header-column">Overseas Agent</th><td>{{ detail.overseasAgent }}</td></tr>
                        <tr><th class="header-column">Category</th><td>{{ detail.categoryName }}</td></tr>
                        <tr><th class="header-column">Planned Time</th><td>{{ detail.targetDateTime | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
                        <tr><th class="header-column">Latest ETA</th><td>{{ detail.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm'  }}</td></tr>
                        <tr><th class="header-column">Assigned User</th><td>{{ detail.assignedUser }}</td></tr>
                        <tr><th class="header-column">Last Modified</th><td>{{ detail.lastModifiedDate | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
                        <tr><th class="header-column">Last Action Date</th><td>{{ detail.lastActionDate | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
                        <tr><th class="header-column">Last Action</th><td>{{ detail.latestAction }}</td></tr>
                        <tr><th class="header-column">Next Update Due By</th><td>{{ detail.updateDueDate | date: 'dd-MMM-yyyy HH:mm' }}</td>
                        <tr><th class="header-column">Note</th><td>{{ detail.latestNote }}</td></tr>

                        <tr><th class="header-column">EADMRN No</th><td>{{ detail.eadmrnNo }}</td></tr>
                        <tr><th class="header-column">TADLRN No</th><td>{{ detail.tadlrnNo }}</td></tr>
                        <tr><th class="header-column">Customs Entry No</th><td>{{ detail.customsEntryNno }}</td></tr>
                        <tr><th class="header-column">HMRC Status</th><td>{{ detail.hmrcStatus }}</td></tr>
                        <tr><th class="header-column">Customs Entry No Sent To Carrier</th><td>{{ detail.customsEntryNoSentToCarrier === 0 ? 'No' : 'Yes' }}</td></tr>
                        <tr><th class="header-column">EAD Filed</th><td>{{ detail.eadFiled === 0 ? 'No' : 'Yes' }}</td></tr>
                        <tr><th class="header-column">EAD Sent</th><td>{{ detail.eadSent === 0 ? 'No' : 'Yes' }}</td></tr>
                        <tr><th class="header-column">EXS Filed</th><td>{{ detail.exsFiled === 0 ? 'No' : 'Yes' }}</td></tr>
                        <tr><th class="header-column">EXS Sent</th><td>{{ detail.exsSent === 0 ? 'No' : 'Yes' }}</td></tr>
                        <tr><th class="header-column">GMR Filed</th><td>{{ detail.gmrFiled === 0 ? 'No' : 'Yes' }}</td></tr>
                        <tr><th class="header-column">GMR Sent To Carrier</th><td>{{ detail.gmrSentToCarrier === 0 ? 'No' : 'Yes' }}</td></tr>
                        <tr><th class="header-column">TADLRN Sent</th><td>{{ detail.tadlrnSent === 0 ? 'No' : 'Yes' }}</td></tr>
                        <tr><th class="header-column">Customs Status</th><td>{{ detail.customsStatus }}</td></tr>

            <!--

                            <tr><th class="header-column">Customer Number        </th><td>{{ detail.customerNumber }}</td></tr>
                            <tr><th class="header-column">Total Sales In GBP       </th><td>{{ detail.totalSalesInGBP }}</td></tr>
                            <tr><th class="header-column">Receiver Country       </th><td>{{ detail.receiverCountry }}</td></tr>
                            <tr><th class="header-column">Receiver Name          </th><td>{{ detail.receiverName }}</td></tr>
                            <tr><th class="header-column">Receiver City          </th><td>{{ detail.receiverCity }}</td></tr>
                            <tr><th class="header-column">Sender Country         </th><td>{{ detail.senderCountry }}</td></tr>
                            <tr><th class="header-column">Sender Name            </th><td>{{ detail.senderName }}</td></tr>
                            <tr><th class="header-column">Sender City            </th><td>{{ detail.senderCity }}</td></tr>

                            <tr><th class="header-column">Collection Address            </th><td>{{ detail.collectionAddress }}</td></tr>


                            <tr><th class="header-column">Delivery Address</th><td>{{ detail.destination }}</td></tr>
                            <tr><th class="header-column">Type</th><td>{{ detail.typeName }}</td></tr> -->
                            <!-- </tr> -->
                    </table>
                </div>
            </mat-tab>
            <!--Vehicle history tab-->
                <mat-tab label="Vehicle History" *ngIf="false">
                    <table class="tgrey" mat-table matSort [dataSource]="dataSource" style="width: 100%;" class="details-table">

                        <ng-container matColumnDef="positionDateTime">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column">
                                Position DateTime</th>
                            <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                                {{ element.positionDateTime | date: 'medium' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                                Address</th>
                            <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                                {{ element.addressInfo}}</td>
                        </ng-container>

                        <ng-container matColumnDef="countryCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                                Country Code</th>
                            <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                                {{element.countryCode}}</td>
                        </ng-container>

                        <ng-container matColumnDef="zipCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                                Zip Code</th>
                            <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                                {{element.zipCode}}</td>
                        </ng-container>

                        <ng-container matColumnDef="nearestCity">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                                Nearest City</th>
                            <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                                {{element.nearestCity}}</td>
                        </ng-container>

                        <ng-container matColumnDef="isManual">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                                Manual Input</th>
                            <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                                {{element.isManual === true ? "Yes": "No"}}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="dataSourceConfig.columns"></tr>
                        <tr mat-row *matRowDef="let row; columns: dataSourceConfig.columns"></tr>

                    </table>
                    <div class="card-spacer">
                        <mat-paginator (page)="page($event)" [pageSizeOptions]="dataSourceConfig.pageSizeOptions"
                            showFirstLastButtons></mat-paginator>
                    </div>
            </mat-tab>
            <!-- Map Tab -->
            <mat-tab label="Map">
              <ng-template matTabContent>
                <div style="  height: 66vh;" class="map-container">
                  <agm-map [latitude]="lat" [longitude]="lng" [zoom]="5" (mapReady)="onMapReady($event)">
                        <!--Destination maker-->
                        <agm-marker [latitude]="lat" [longitude]="lng" [title]="detail?.destination" [draggable]="false"
                            [title]="'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') + '\nDelta: ' + getTimeDifference(detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd, detail?.estimatedDateTime)"
                            [iconUrl]="{url:getIcon('Delivery',detail?.updateBy), scaledSize: {width: 45,height: 60}}"
                            >
                            <agm-info-window>
                                <strong>Destination: {{detail?.destination}}</strong>
                            </agm-info-window>
                        </agm-marker>
                        <!--Vehicle maker-->
                        <agm-marker *ngIf="(vehicleDet?.positionDateTime !== undefined || vehicleDet?.positionDateTime !== null)"
                                    [latitude]="vehicleDet?.latitude"
                                    [longitude]="vehicleDet?.longitude"
                                    matTooltip="text"
                                    [title]="'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') + '\nDelta: ' + getTimeDifference(detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd, detail?.estimatedDateTime)"
                                    [draggable]="false"
                                [iconUrl]="detail?.updateTypeName === 'Driver Rest Start' ? {url:'./assets/images/Driver-rest-icon.png', scaledSize: {width: 45,height: 55} } : {url: getTruckIcon((detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd), detail?.estimatedDateTime, (detail?.type === 'Collection' ? detail?.actualCollectionDate : detail?.actualDeliveryDate)), scaledSize: {width: 45,height: 55} }">
                            <agm-info-window>
                                <strong>Reg Nr: {{vehicleDet?.vehicleLicensePlate}}</strong><br>
                                <strong>Position Date: {{vehicleDet?.positionDateTime | date: 'dd-MMM-yyyy HH:mm'}}</strong><br>
                                <strong>Next location: {{detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination}}</strong><br>
                                <strong>ETA: {{detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm'}}</strong><br>
                                <strong>Delta: {{ getTimeDifference(detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd, detail?.estimatedDateTime) }}</strong>
                            </agm-info-window>
                        </agm-marker>
                        <!--Collection maker-->
                        <agm-marker [latitude]="collectionLat" [longitude]="collectionLng" [draggable]="false"
                        [title]="'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') + '\nDelta: ' + getTimeDifference(detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd, detail?.estimatedDateTime)"
                            [iconUrl]="{url:getIcon('Collection',detail?.updateBy), scaledSize: {width: 45,height: 60}}"
                            >
                            <agm-info-window>
                                <strong>Collection: {{detail?.collectionAddress}}</strong>
                            </agm-info-window>
                        </agm-marker>
                        <agm-marker
                          *ngFor="let event of bmwVehicleMarkerEvents"
                          [latitude]="event.latitude"
                          [longitude]="event.longitude"
                          [title]="getEventTitle(event)"
                          [iconUrl]="{ url: 'assets/images/amco-green-truck.png', scaledSize: { width: 35, height: 45 } }">
                          <agm-info-window>
                            <div>
                              <strong>Reg:</strong> {{ event.vehicleLicensePlate }}<br>
                              <strong>Date:</strong> {{ event.positionDateTime | date: 'dd-MMM-yyyy HH:mm' }}<br>
                            </div>
                          </agm-info-window>
                        </agm-marker>
                        <agm-polyline
                          *ngIf="bmwVehiclePolylinePoints.length > 1"
                          [strokeColor]="'#15457e'"
                          [strokeWeight]="2"
                          [editable]="false"
                          [visible]="true">
                          <agm-polyline-point
                            *ngFor="let point of bmwVehiclePolylinePoints"
                            [latitude]="point.lat"
                            [longitude]="point.lng">
                          </agm-polyline-point>
                        </agm-polyline>
                        <!--Blue/Google/Route Line
                        <agm-polyline [strokeColor]="'blue'" [strokeWeight]="2" [editable]="false" [visible]="true" >
                            <agm-polyline-point *ngFor="let s of polylinePoints; let i=index;" [latitude]="s.lat"
                                [longitude]="s.lng">

                            </agm-polyline-point>
                        </agm-polyline> -->

                          <!--Red/Google/Route Line
                          <agm-polyline [strokeColor]="'#15457e'" [strokeWeight]="2" [editable]="false" [visible]="true" >
                            <agm-polyline-point *ngFor="let s of redPolylinePoints; let i=index;" [latitude]="s.lat"
                              [longitude]="s.lng">

                            </agm-polyline-point>
                          </agm-polyline>  -->

                        </agm-map>
                      </div>
                    </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
    </div>
</mat-card>
